const outlinedVariant = ({ theme }) => ({
	border: '1px solid',
	borderColor: theme.palette.grey[300],
});

const paddedVariant = ({ theme }) => ({
	padding: theme.spacing(3),
});

const internalAppsOverrides = ({ ownerState, theme }) => ({
	...(ownerState.variant === 'EveSideNavigation' && {
		...outlinedVariant({ theme }),
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
		paddingLeft: 0,
		paddingRight: 0,
		width: '278px',
		marginRight: theme.spacing(6),
	}),
	...(ownerState.variant !== 'EveSideNavigation' && {
		'&:not(:last-of-type)': {
			marginBottom: theme.spacing(3),
		},
	}),
	...(ownerState.variant === 'EveOutlinedPaddedSplit' && {
		...outlinedVariant({ theme }),
		...paddedVariant({ theme }),
		'& .MuiDivider-vertical': {
			marginLeft: theme.spacing(5),
			marginRight: theme.spacing(5),
		},
	}),
});

export default {
	styleOverrides: {
		root: ({ ownerState, theme }) => ({
			...(theme.themeKey === 'internal'
				? internalAppsOverrides({ ownerState, theme })
				: {}),
			...(ownerState.variant === 'wrapper' && {
				padding: theme.spacing(4),
			}),
			...(ownerState.variant === 'EveOutlined' && {
				...outlinedVariant({ theme }),
				padding: 0,
			}),
			...(ownerState.variant === 'EveOutlinedPadded' && {
				...outlinedVariant({ theme }),
				...paddedVariant({ theme }),
			}),
		}),
	},
};
